import { AnimatePresence } from "motion/react";
import { createContext, useCallback, useContext } from "react";
import * as motion from "motion/react-client";
import useScreenDimensions from "../hooks/useScreenDimensions";

import { create } from 'zustand';
import { StandardButton } from "./standardButton";
import { useNavigate } from "react-router";

interface BasicState {
  isOpen: boolean;
  setIsOpen: (newVal: boolean) => void;
}

export const useDontHaveASubModal = create<BasicState>((set) => ({
  isOpen: false,
  setIsOpen: (newVal: boolean) => set({ isOpen: newVal }),
}));


export const DontHaveASubModal = () => {
  const isOpen = useDontHaveASubModal(state=>state.isOpen)
  const setIsOpen = useDontHaveASubModal(state => state.setIsOpen)
  const { width, height } = useScreenDimensions();

  const nav = useNavigate();

  const cancelEvent = (e: React.MouseEvent) => e.stopPropagation();

  const closeModal = () => {
    setIsOpen(false);
  }

  const redirect = useCallback(() => {
    nav('/plans')
  }, [nav])


  return (

    <AnimatePresence>
      {isOpen ? (
        <motion.div
          key={"campaignModal"}
          style={{
            width,
            height,
            backgroundColor: "rgba(0, 0, 0, .3)",
            position: "fixed",
            zIndex: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            top: 0,
            left: 0,
          }}
          onClick={closeModal}
          animate={{ opacity: 1 }}
          initial={{ opacity: 0 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={cancelEvent}
            style={{
              width: "40rem",
              minWidth: 400,
              backgroundColor: "white",
              padding: 24,
              borderRadius: 16,
              opacity: 1,
            }}
          >
            <div style={{fontWeight: 500, fontSize: '1.2rem', marginBottom: '1rem'}}>
                          Hold on there
                        </div>
                        <div style={{marginBottom: '.5rem'}}>
                          It looks like you don't have an active subscription
                        </div>
                        <div style={{marginBottom: '1rem'}}>
                          Use the button below to pick your plan and get back to collecting reviews
                        </div>
                        <StandardButton buttonText="Pick a Plan" onClick={redirect} />
                      </div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
